import { createStyles, withStyles, WithStyles } from '@domonda/ui/styles';

const styles = createStyles(({ palette, shadows, spacing, shape }) => ({
  splitterContainer: {
    margin: spacing(1, 0),
    textAlign: 'center',
  },
  thumbsInvoice: {
    padding: spacing(0, 1, 1, 1),
  },
  thumbsInvoiceInner: {
    overflow: 'hidden',
    padding: spacing(1),
    border: '2px solid transparent',
    borderRadius: shape.borderRadius,
  },
  thumbsInvoiceInnerClickable: {
    cursor: 'pointer',
    transition: 'background-color 200ms, border-color 200ms',
    '&:hover, &:focus': {
      backgroundColor: palette.background,
    },
    '&:active': {
      backgroundColor: palette.dark('background'),
    },
  },
  thumbsInvoiceInnerSelected: {
    borderColor: palette.primary,
  },
  thumbsInvoicePage: {
    overflow: 'hidden',
    border: `1px solid ${palette.border}`,
    borderRadius: shape.borderRadius,
    backgroundColor: palette.surface,
    boxShadow: shadows[2],
  },
}));

export type Decorate = WithStyles<typeof styles>;

export const decorate = withStyles(styles);
